import React, { useState, useRef, useEffect } from 'react';
import { usePdf } from '@mikecousins/react-pdf';
import { Button } from 'reactstrap';
import { ChevronRight, ChevronLeft, ZoomIn, ZoomOut} from '@material-ui/icons';
import ExpandIcon from '../../../../../assets/images/module/general/ExpandIcon.svg';
import { Group, Loader, Stack } from '@mantine/core';
import { formatNumber } from '../../../../../helpers/stringsManipulations';
import { isStarterTier } from '../../../../../helpers/subscriptionFeatureAccess';
import dayjs from 'dayjs';
import accounting from 'accounting';
import Autoload from '../../../../Autoload.js';

const { mergeBlobUrls } = require('../../../../../helpers/pdfHelper.js');
const MOBILE_SIZE = 992;
const SMALLER_MOBILE_SIZE = 500;
var { generateFileNameForMessagePdf } = Autoload.MainHelper;

const PreviewMessageTenantPortal = ({messageData, selectedRecipient, senderEmail, senderProfile, billingPeriod, rentalUnits, propertySelected, selectedBillingStatement, accountData, meterReadingsSwitch, compositionOfHeatingCostsSwitch, costSplitWarmWaterAndHeatingSwitch, splitBaseConsumptionCostsSwitch, heatingFilter, senderAddress, rentalPayment, rents, profile, tenantRemainingRentObject, vatSwitch, isPreTaxInfoHidden, currentSubscription, laborCostSwitch, energyConsumptionCO2EmissionsSwitch, compareHeatingConsumptionBarChartSwitch, energyLevelsInfoSwitch, arbitraryBoardInfoSwitch, energyAdviceCenterInfoSwitch, co2TaxInfoSwitch, multipleTenants, messagePreviewPdf=null, ubPdfUrl=null}) => {
    console.log('PreviewMessage: ', messageData, selectedRecipient, senderProfile);

    const [newMessageBody, setNewMessageBody] = useState();
    const [newMessageSubject, setNewMessageSubject] = useState();
    const [rentalUnit, setRentalUnit] = useState();
    const [propertyAddress, setPropertyAddress] = useState();

    const replaceAllPlaceHolders = (type) => {
  let content = type === 'body' ? messageData.body : messageData.subject;

  // 1. Calculate prerequisite variables (Kept exactly as you had them)
  let rentalUnit = rentalUnits.find((ru) => ru.tenantsData.find((tenant) => tenant.id === selectedRecipient.tenantId) !== undefined);
  let tenant = rentalUnit?.tenantsData.find((tenant) => tenant.id === selectedRecipient.tenantId);
  let rent = null;
  
  if (messageData.templateType === 'RentalPayment') {
    let findRentalPaymentRent = rents.find((rt) => (dayjs(rt.startDate).isSame(rentalPayment.rentalMonth) || dayjs(rt.startDate).isBefore(rentalPayment.rentalMonth)) && (rt.endDate ? (dayjs(rt.endDate).isSame(rentalPayment.rentalMonth) || dayjs(rt.endDate).isAfter(rentalPayment.rentalMonth)) : true));
    rent = findRentalPaymentRent !== undefined ? findRentalPaymentRent : null;
  } else {
    let findRent = rents.find((rt) => (dayjs(rt.startDate).isSame(new Date()) || dayjs(rt.startDate).isBefore(new Date())) && (rt.endDate ? (dayjs(rt.endDate).isSame(new Date()) || dayjs(rt.endDate).isAfter(new Date())) : true));
    rent = findRent !== undefined ? findRent : null;
  }

  const commercialTenantWithVatSwitch = vatSwitch && !isStarterTier(currentSubscription) && (selectedBillingStatement?.tenantOccupation.contractType === 'Default' || selectedBillingStatement?.tenantOccupation.contractType === 'commercial' || selectedBillingStatement?.tenantOccupation.contractType === 'self');
  const sumOfVAT = selectedBillingStatement?.totalVATAmount ? selectedBillingStatement?.totalVATAmount : 0;
  const netUtilityBillingCost = (selectedBillingStatement ? selectedBillingStatement?.totalAllocatedUtilityCosts : 0) - sumOfVAT;
  const VAT = (isPreTaxInfoHidden ? selectedBillingStatement?.totalAllocatedUtilityCosts : netUtilityBillingCost) * 0.19;
  const grossUtilityBillingCost = !isPreTaxInfoHidden ? (netUtilityBillingCost + VAT) : ((selectedBillingStatement ? selectedBillingStatement?.totalAllocatedUtilityCosts : 0) + VAT);
  const creditAmount = selectedBillingStatement ? selectedBillingStatement?.totalAdvancePayments - grossUtilityBillingCost : 0;

  console.log('rentalUnit: ', rentalUnit);
  setRentalUnit(rentalUnit);

  const isRegularCreditValid = selectedBillingStatement?.totalAllocatedUtilityCosts !== null && selectedBillingStatement?.totalAdvancePayments !== null;
  const regularCreditAmount = isRegularCreditValid ? (selectedBillingStatement?.totalAdvancePayments - selectedBillingStatement?.totalAllocatedUtilityCosts) : 0;

  // 2. Define a map of all placeholder labels to their dynamic values
  const placeholderValues = {
    'Abrechnungszeitraum': `${dayjs(selectedBillingStatement?.tenantOccupation?.startDate, 'YYYY-MM-DD').format('DD.MM.YYYY')} - ${dayjs(selectedBillingStatement?.tenantOccupation?.endDate, 'YYYY-MM-DD').format('DD.MM.YYYY')}`,
    'Betriebskosten': commercialTenantWithVatSwitch ? accounting.formatMoney(grossUtilityBillingCost, '€', 2, '.', ',', '%v %s') : (selectedBillingStatement?.totalAllocatedUtilityCosts !== null ? formatNumber(selectedBillingStatement?.totalAllocatedUtilityCosts, true) : ''),
    'Empfänger': selectedRecipient?.name || '',
    'Guthaben / Nachzahlung': commercialTenantWithVatSwitch 
                ? `${creditAmount > 0 ? '+' : ''}${accounting.formatMoney(creditAmount, '€', 2, '.', ',', '%v %s')}` 
                : (isRegularCreditValid ? `${regularCreditAmount > 0 ? '+' : ''}${formatNumber(regularCreditAmount, true)}` : ''),
    'Mieteinheit': rentalUnit?.name || '',
    'Objektadresse': (propertySelected.propertyAddress && propertySelected.propertyZipCode && propertySelected.propertyCity) ? `${propertySelected.propertyAddress}, ${propertySelected.propertyZipCode} ${propertySelected.propertyCity}` : '',
    'Vorauszahlungen': selectedBillingStatement?.totalAdvancePayments !== null ? formatNumber(selectedBillingStatement?.totalAdvancePayments, true) : '',
    'Absender': `${profile?.firstName || ''} ${profile?.lastName || ''}`,
    'Mieter': tenant?.name || '',
    'Auszugsdatum': tenant?.out || '',
    'Einzugsdatum': tenant?.in || '',
    'erhaltene Miete': rentalPayment ? accounting.formatMoney((rentalPayment.receivedNetRent + rentalPayment.receivedAdvancePayment), '€', 2, '.', ',', '%v %s') : '',
    'Mietmonat': rentalPayment ? dayjs(rentalPayment.rentalMonth).format('MMMM YYYY') : '',
    'gesamte ausstehende Miete': tenantRemainingRentObject !== null ? accounting.formatMoney(tenantRemainingRentObject, '€', 2, '.', ',', '%v %s') : '',
    'Vermieter': accountData?.addressCompany || '',
    'Vorauszahlung': rent ? accounting.formatMoney(rent.prePayments, '€', 2, '.', ',', '%v %s') : (rents.length > 0 ? accounting.formatMoney(rents[0].prePayments, '€', 2, '.', ',', '%v %s') : ''),
    'Warmmiete': rent ? accounting.formatMoney(rent.prePayments + rent.netRent, '€', 2, '.', ',', '%v %s') : (rents.length > 0 ? accounting.formatMoney(rents[0].prePayments + rents[0].netRent, '€', 2, '.', ',', '%v %s') : ''),
    'Kaltmiete': rent ? accounting.formatMoney(rent.netRent, '€', 2, '.', ',', '%v %s') : (rents.length > 0 ? accounting.formatMoney(rents[0].netRent, '€', 2, '.', ',', '%v %s') : ''),
    'Zugangslink': `https://${window.location.href.includes('app') ? 'app' : 'dev'}.hellohousing-mieterportal.de/signup?${multipleTenants.find((mTenant)=> mTenant?.userId === selectedRecipient?.tenantId)?.passwordResetCode}`,
    'Eigentümer': propertySelected?.propertyOwner?.name || ''
  };

  // 3. Regex to match <a href="", href="#", or href="#disabled" target="_self">PlaceholderKey</a>
  const regex = /<a href="(?:#|#disabled|)" target="_self">([^<]+)<\/a>/g;

  // 4. Perform a single pass replacement
  let newContent = content.replace(regex, (match, placeholderKey) => {
    // If the text inside the <a> tag matches a key in our map, inject the value. 
    // Otherwise, leave the tag alone.
    return placeholderValues[placeholderKey] !== undefined ? placeholderValues[placeholderKey] : match;
  });

  console.log('newMessageData: ', newContent);
  
  if (type === 'body') {
    setNewMessageBody(newContent);
  } else {
    setNewMessageSubject(newContent);
  }
}
    
    const createPdf= async () => {
      if(messageData?.utilityBillingId){
        if(messagePreviewPdf && ubPdfUrl){
          await mergeBlobUrls([messagePreviewPdf, ubPdfUrl], generateFileNameForMessagePdf(selectedRecipient, messageData));
        }
        //window.open(`/billingStatement2/${selectedBillingStatement.id}?heatingFilter=${heatingFilter}&meterReadings=${meterReadingsSwitch}&compositionOfHeatingCosts=${compositionOfHeatingCostsSwitch}&costSplitWarmWaterAndHeating=${costSplitWarmWaterAndHeatingSwitch}&splitBaseConsumptionCosts=${splitBaseConsumptionCostsSwitch}&energyConsumptionCO2EmissionsSwitch=${energyConsumptionCO2EmissionsSwitch}&compareHeatingConsumptionBarChartSwitch=${compareHeatingConsumptionBarChartSwitch}&energyLevelsInfoSwitch=${energyLevelsInfoSwitch}&arbitraryBoardInfoSwitch=${arbitraryBoardInfoSwitch}&energyAdviceCenterInfoSwitch=${energyAdviceCenterInfoSwitch}&co2TaxInfoSwitch=${co2TaxInfoSwitch}&vatSwitch=${vatSwitch}&laborCostSwitch=${laborCostSwitch}&isPreTaxInfoHidden=${isPreTaxInfoHidden || null}`)
      }else if(messagePreviewPdf){
        const link = document.createElement("a");
        link.href = messagePreviewPdf;
        link.download = `${selectedRecipient?.name || 'Nachricht'}.pdf`; //messageData?.subject ? `${messageData?.subject?.replace(/<[^>]*>/g, '')}.pdf` : 'Nachricht.pdf';
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      }
        //window.open(`/billingStatement2/${selectedBillingStatement.id}?heatingFilter=${heatingFilter}&meterReadings=${meterReadingsSwitch}&compositionOfHeatingCosts=${compositionOfHeatingCostsSwitch}&costSplitWarmWaterAndHeating=${costSplitWarmWaterAndHeatingSwitch}&splitBaseConsumptionCosts=${splitBaseConsumptionCostsSwitch}&vatSwitch=${vatSwitch}&laborCostSwitch=${laborCostSwitch}`, '_blank');
        //window.open(`/billingStatement2/${selectedBillingStatement.id}?heatingFilter=${heatingFilter}&meterReadings=${meterReadingsSwitch}&compositionOfHeatingCosts=${compositionOfHeatingCostsSwitch}&costSplitWarmWaterAndHeating=${costSplitWarmWaterAndHeatingSwitch}&splitBaseConsumptionCosts=${splitBaseConsumptionCostsSwitch}&energyConsumptionCO2EmissionsSwitch=${energyConsumptionCO2EmissionsSwitch}&compareHeatingConsumptionBarChartSwitch=${compareHeatingConsumptionBarChartSwitch}&energyLevelsInfoSwitch=${energyLevelsInfoSwitch}&arbitraryBoardInfoSwitch=${arbitraryBoardInfoSwitch}&energyAdviceCenterInfoSwitch=${energyAdviceCenterInfoSwitch}&co2TaxInfoSwitch=${co2TaxInfoSwitch}&vatSwitch=${vatSwitch}&laborCostSwitch=${laborCostSwitch}&isPreTaxInfoHidden=${isPreTaxInfoHidden}`)
    }
    
    useEffect(() => {
      replaceAllPlaceHolders('body');
      replaceAllPlaceHolders('subject');

      if(propertySelected?.isPropertyOwnerInfoEnabled && propertySelected?.isPropertyOwnerInfoInMessagesEnabled){
        const {propertyOwner} = propertySelected;
        let newSenderAddress = {
          name: propertyOwner?.name,
          street: propertyOwner?.street,
          postalCode: propertyOwner?.postalCode,
          city: propertyOwner?.city,
          phoneNumber: propertyOwner?.phoneNumber,
          email: propertyOwner?.email
        }
        setPropertyAddress(newSenderAddress)
      }else{
        let newSenderAddress = {
          name: accountData?.addressCompany,
          street: accountData?.addressStreet,
          postalCode: accountData?.addressZipCode,
          city: accountData?.addressCity,
          phoneNumber: accountData?.companyPhoneNumber,
          email: accountData?.companyEmail
        }
        setPropertyAddress(newSenderAddress)
      }
    },[selectedRecipient]);
  return (
    <div style={{width: '210mm', //height: '297mm', 
    background: 'white', //boxShadow: '0px 1px 2px #000', 
    padding: '23mm'}}>
      <Group gap={2}>
            <span style={{fontSize: '16px', fontWeight: 600, fontFamily: 'Arial', textAlign: 'justify', color: '#000'}}>Betreff:</span>
            <div className={'message-card-title'} style={{fontSize: '16px', fontWeight: 600, fontFamily: 'Arial', textAlign: 'justify', color: '#000'}} dangerouslySetInnerHTML={{__html: newMessageSubject}}/>  
        </Group>
      <div className='div-message-preview-body' style={{marginTop: '20mm', fontSize: '12px', fontFamily: 'Arial', textAlign: 'justify'}} dangerouslySetInnerHTML={{__html: newMessageBody}}/>
      <Stack gap={10}>
        <Stack gap={0}>
            {/* <span style={{fontFamily: 'Arial', fontSize: '9pt'}}>{`Mit freundlichen Grüßen`}</span> */}
            <span style={{fontFamily: 'Arial', fontSize: '9pt'}}>{propertyAddress?.name}</span>
            <span style={{fontFamily: 'Arial', fontSize: '9pt'}}>{propertyAddress?.street}</span>
            <span style={{fontFamily: 'Arial', fontSize: '9pt'}}>{`${propertyAddress?.postalCode} ${propertyAddress?.city}`}</span>
        </Stack>
        <Stack gap={0}>
          {propertyAddress?.phoneNumber && <span style={{fontFamily: 'Arial', fontSize: '8pt'}}>{`Telefon: ${propertyAddress?.phoneNumber}`}</span>}
          {propertyAddress?.email && <span style={{fontFamily: 'Arial', fontSize: '8pt'}}>{`E-Mail: ${propertyAddress?.email}`}</span>}
        </Stack>
      </Stack>
      <Stack style={{fontSize: '12px', fontWeight: 400, marginTop: '20px'}} gap={0}>
        <Group gap={2}>
          <span style={{fontWeight: 'bold'}}>Anhang:</span>
          {(messageData?.utilityBillingId ? (messagePreviewPdf === null && ubPdfUrl === null) : messagePreviewPdf === null)  ? 
          <Loader size={12}/> 
          : 
          <span style={{cursor: 'pointer', marginLeft: '1px', color: '#5555FF'}} onClick={()=> createPdf()}>{generateFileNameForMessagePdf(selectedRecipient, messageData)}</span>}
        </Group>
      </Stack>
    </div>
  );
};

export default PreviewMessageTenantPortal;